class VideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.items = Array.from(this.querySelectorAll('.video-carousel__item'));
    this.current = -1;
    this.fallbackTimer = null;
    this.handleEnded = this.next.bind(this);
  }

  connectedCallback() {
    if (this.items.length) this.showItem(0);
  }

  showItem(index) {
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
      this.fallbackTimer = null;
    }

    const previous = this.items[this.current];
    if (previous) {
      previous.classList.remove('is-active');
      const video = previous.querySelector('video');
      const iframe = previous.querySelector('iframe');
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.removeEventListener('ended', this.handleEnded);
      }
      if (iframe) iframe.src = '';
    }

    this.current = index;
    const active = this.items[this.current];
    active.classList.add('is-active');

    const video = active.querySelector('video');
    const iframe = active.querySelector('iframe');

    if (video) {
      video.muted = true;
      video.addEventListener('ended', this.handleEnded, { once: true });
      video.play().catch(() => {});
    } else if (iframe) {
      const baseSrc = iframe.dataset.src;
      const separator = baseSrc.includes('?') ? '&' : '?';
      iframe.src = `${baseSrc}${separator}autoplay=1&mute=1`;
      this.fallbackTimer = setTimeout(this.handleEnded, 15000);
    }
  }

  next() {
    if (this.items.length < 2) return;
    this.showItem((this.current + 1) % this.items.length);
  }
}

customElements.define('video-carousel', VideoCarousel);
